export default {
      id: "icon-arrow-usage",
      viewBox: "0 0 22.56 22.93",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-arrow",
      toString: function () {
        return this.url;
      }
    }